import { Outlet } from 'react-router'

export const UnAuthLayout = () => {
	return <>
		<Outlet />
	</>
}
